import { InspectionTemplatesPage } from "./InspectionTemplatesPage";

const InspectionTemplates = () => {
	return <InspectionTemplatesPage />;
};

export default InspectionTemplates;
